import { Injectable } from '@angular/core'
import { HttpClient, HttpEvent } from '@angular/common/http'
import { environment } from 'src/environments/environment'
import { CookieService } from 'ngx-cookie-service'
import { UserCookiePipe } from 'src/app/pipe/user-cookie-pipe'

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(private http: HttpClient,
        private cookie: CookieService,
        private userCookie: UserCookiePipe) {
    }

    login(user: any) {
        return this.http.post(`${environment.apiBaseUrl}/login`, user)
    }

    signup(user: any) {
        return this.http.post(`${environment.apiBaseUrl}/signup`, user)
    }

    logout(): void {
        localStorage.removeItem("MAIN_MENU");
        localStorage.removeItem("SUB_MENU");
        localStorage.removeItem("SUB_MENU");
        this.cookie.delete('user')
    }
}
